const apiUrl = process.env.REACT_APP_API_URL;

export async function PostProblemaRecompensa(idProblema: string, recompensa: any) {
    const url = `${apiUrl}:8061/jutge/problema/${idProblema}/recompenses`;
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(recompensa)
        });
        if (!response.ok) return false;
        return true;
    } catch (e) {
        return false;
    }
}
